<template>
  <!-- TODO remove class btn after refactor it using in other component -->
  <component
    :is="tag"
    :class="['button', 'btn', btnClasses]"
    :disabled="loading"
  >
    <div
      class="button__content"
    >
      <slot>Button</slot>
    </div>
    <BaseSpinner
      v-if="loading"
      show
      small
    />
  </component>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
} from 'vue';
import BaseSpinner from 'Components/Base/BaseSpinner.vue';

export default defineComponent({
  name: 'BaseButton',
  components: { BaseSpinner },
  props: {
    /**
     * default button, can be: button/a/router-link
     */
    tag: {
      type: String,
      default: 'button',
    },
    large: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    xsmall: {
      type: Boolean,
      default: false,
    },
    /** color - background state for btn
     * default primary, can be: primary/outlined/outlined-gray/transparent
     */
    color: {
      type: String,
      validator: (value: string) => ['primary', 'primary-dark', 'outlined', 'outlined-gray', 'transparent'].includes(value),
      default: 'primary',
    },
    block: Boolean,
    disabled: Boolean,
    loading: Boolean,
  },
  setup(props) {
    const btnClasses = computed(() => {
      let classes = `is--${props.color} `;
      classes += props.large ? 'is--large ' : '';
      classes += props.small ? 'is--small ' : '';
      classes += props.block ? 'is--block ' : '';
      classes += props.xsmall ? 'is--xsmall ' : '';
      classes += props.disabled ? 'is--disabled ' : '';
      classes += props.loading ? 'is--loading ' : '';
      return classes;
    });

    return {
      btnClasses,
    };
  },
});
</script>

<style lang="sass">
@import '~Styles/_variables'
.button
  display: inline-flex
  justify-content: center
  align-items: center
  border: unset
  height: 40px
  +font(500)
  color: $white
  background-color: $secondary
  border-radius: 0px
  padding: 0 12px
  font-size: 16px
  cursor: pointer
  position: relative
  +mt(.3s)
  &:hover
    color: $white
    +mt(.3s)
  &:focus
    color: $white
  &.is--xsmall
    height: 31px
    padding: 0 10px
    font-size: 12px
    +font(400)
  &.is--small
    height: 32px
    padding: 0 12px
    font-size: 14px
    .btn-icon
      width: 12px
      height: 12px
      margin-left: 4px
      margin-right: 4px
  &.is--large
    height: 48px
    padding: 0 18px
  &.is--primary
    fill: $white !important
    &:hover
      background-color: $chalet_green
  &.is--primary-dark
    background-color: $white
    color: $gray-100
    &:hover
      background-color: $gray-30
      color: $gray-100
    &:active
      transition: all 0.3s ease-in-out
      background-color: $gray-30
    &:focus
      transition: all 0.3s ease-in-out
      outline: 1px solid $gray-10
      outline-offset: -3px
      background-color: $gray-100
  &.is--outlined
    color: $secondary
    background-color: transparent
    border: solid 2px $secondary
    fill: $secondary !important
    &:hover
      +mt(.3s)
      border-color: $chalet_green
      color: $white
      fill: $white !important
      background-color: $chalet_green
    &:active,
    &:focus
      color: $white
      fill: $white !important
      border-color: $everglade
      background-color: $everglade
  &.is--outlined-gray
    color: $alabaster
    fill: $alabaster
    background-color: transparent
    border: solid 2px $alabaster
    &:hover
      transition: all 0.3s ease-in-out
      color: $bunker
      fill: $bunker
      border: solid 2px $alabaster
      background-color: $alabaster
    &:active
      transition: all 0.3s ease-in-out
      color: $bunker
      fill: $bunker
      border: solid 2px $mercury
      background-color: $mercury
    &:focus
      transition: all 0.3s ease-in-out
      color: $bunker
      fill: $bunker
      border: solid 2px $alabaster
      background-color: $alabaster
      &:before
        content: ''
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 100%
        border: solid 1px $bunker
  &.is--transparent
    color: $secondary
    fill: $secondary
    background-color: transparent
    &:hover
      transition: all 0.3s ease-in-out
      color: $secondary
      fill: $secondary !important
      background-color: $gray-10
    &:active
      transition: all 0.3s ease-in-out
      color: $secondary
      fill: $secondary !important
      background-color: $support_lightgray
    &:focus
      transition: all 0.3s ease-in-out
      color: $secondary
      fill: $secondary !important
      border: solid 2px $shakespeare
      background-color: transparent
  &.is--block
    width: 100%
  &.is--disabled
    opacity: 0.3
  .is--loading &__content
    opacity: 0
  &__content
    transition: opacity .3s
    display: flex
    align-items: center
    justify-content: center
    flex-shrink: 0
  &__left-icon
    margin-right: 12px
  &__right-icon
    margin-left: 12px
</style>
